import React, { useEffect } from 'react';

import { Box, Button, Divider, Stack } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import ReactHookFormSelect2 from 'common/components/form/ReactHookFormSelect2';

import * as actions from '../actions';
import * as selectors from '../selectors';

const SelectUserForm = ({
    allianceId,
    callback,
    initialValues,
    save,
    users,
}) => {
    const { t } = useTranslation();

    const { control, handleSubmit, reset } = useForm({
        defaultValues: initialValues,
        mode: 'onChange',
    });

    useEffect(() => reset(initialValues), [initialValues]);

    const handleOnClickSave = (values) =>
        save({ ...values, allianceId: allianceId }, callback);

    // Adjusted options format for ReactHookFormSelect2 (grouped options)
    const usersToSelect = [
        {
            label: 'Users', // Group label, can be adjusted or removed if not needed
            options: [
                {
                    disabled: true,
                    label: t('Select a user'),
                    value: '',
                },
                ...users.map((item) => ({
                    label: `${item.first_name} ${item.last_name}`,
                    value: item.id,
                })),
            ],
        },
    ];

    return (
        <Stack component="form" onSubmit={handleSubmit(handleOnClickSave)}>
            <ReactHookFormSelect2
                control={control}
                name="user"
                options={usersToSelect}
                label=""
            />

            <Divider sx={{ mx: (theme) => `${theme.spacing(-2)}!important` }} />

            <Box sx={{ textAlign: 'right' }}>
                <Button type="submit">{t('Save')}</Button>
            </Box>
        </Stack>
    );
};

const mapStateToProps = createStructuredSelector({
    initialValues: selectors.getInitialValuesAssignUserForm,
});

const mapDispatchToProps = (dispatch) => ({
    save: (values, callback) =>
        dispatch(actions.saveAssignedUser(values, callback)),
});

SelectUserForm.propTypes = {
    allianceId: PropTypes.string,
    callback: PropTypes.func,
    initialValues: PropTypes.object,
    save: PropTypes.func,
    users: PropTypes.array,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectUserForm);
